import React from 'react';
import { useTranslation } from 'react-i18next';

function BigFiveModal({ visible, onClose, onStartTest }) {
  const { t } = useTranslation();

  if (!visible) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-70">
      <div className="bg-white rounded-xl p-8 w-full max-w-md shadow-lg text-center">
        <h2 className="text-2xl font-bold mb-4 text-black">{t('bigFiveModal.heading')}</h2>
        <p className="text-gray-700 mb-6">{t('bigFiveModal.text')}</p>
        <div className="flex justify-between space-x-4">
          <button
            className="flex-1 bg-gray-300 hover:bg-gray-400 text-black font-semibold py-2 px-4 rounded-xl"
            onClick={onClose}
          >
            {t('bigFiveModal.later')}
          </button>
          <button
            className="flex-1 bg-green-400 hover:bg-green-500 text-black font-semibold py-2 px-4 rounded-xl"
            onClick={onStartTest}
          >
            {t('bigFiveModal.start')}
          </button>
        </div>
      </div>
    </div>
  );
}

export default BigFiveModal;
